import { render, staticRenderFns } from "./objectTagAdd.vue?vue&type=template&id=07fd9188"
import script from "./objectTagAdd.vue?vue&type=script&lang=js"
export * from "./objectTagAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07fd9188')) {
      api.createRecord('07fd9188', component.options)
    } else {
      api.reload('07fd9188', component.options)
    }
    module.hot.accept("./objectTagAdd.vue?vue&type=template&id=07fd9188", function () {
      api.rerender('07fd9188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/objectTag/objectTagAdd.vue"
export default component.exports